$(document).ready(function () {

    /*
        MODULES
     */
    $('#main .mod-related-pages .owl-carousel').owlCarousel({
        items: 1,
        loop: false,
        nav: false,
        dots: true,
        margin: 30,
        responsive:{
            480:{
                items:1
            },
            767:{
                items:2
            },
            991:{
                items:3
            },
        }
    });

    $('#main .mod-images-title .owl-carousel').owlCarousel({
        items: 1,
        loop: false,
        nav: false,
        dots: true,
        margin: 30,
        responsive:{
            480:{
                items:1
            },
            767:{
                items:2
            },
            991:{
                items:4
            },
        }
    });

    $('#main .mod-points-forts .owl-carousel').owlCarousel({
        items: 1,
        loop: false,
        nav: false,
        dots: true,
        margin: 30,
        responsive:{
            480:{
                items:1
            },
            767:{
                items:2
            },
            991:{
                items:3
            }
        }
    });

    $('#main .mod-points-forts .block').on('click', function() {
        var dest = $(this).data('href');

        document.location.href = dest;

        return false;
    });

});